import { OutputData } from '@editorjs/editorjs'

export enum SearchResultModel {
	Ambulance = 'ambulance',
	BlogPost = 'blogPost',
	Employee = 'employee',
	AnnualProgram = 'yearProgram',
	PriceListPromo = 'priceListPromo',
	PriceListItem = 'priceListItem',
	PriceListGroup = 'priceListGroup',
	PreventiveExamination = 'preventiveExamination',
	CreditProgram = 'creditProgram'
}

export interface ISearchResult {
	id: number
	slug?: string
	title: string
	description: string | OutputData | null
	model: SearchResultModel
	matchedFields: Record<string, unknown>
	extras: Record<string, any> | null
}

export interface ISearchPaginationLink {
	url: string | null
	label: string
	active: boolean
}

export interface ISearchMeta {
	currentPage: number
	from: number
	lastPage: number
	path: string
	perPage: number
	to: number
	total: number
	links: ISearchPaginationLink[]
}

export interface ISearchLinks {
	first: string | null
	last: string | null
	prev: string | null
	next: string | null
}

export interface ISearchResponse {
	data: ISearchResult[]
	meta: ISearchMeta
	links: ISearchLinks
}
